import { useNavigate } from "react-router-dom";
import { Button, Typography } from "antd";
import PageTitle from "../../components/title/pageTitle";
import Navigation from "../../components/navigation/navigation";
import Footer from "../../components/footer/footer";
import { clearAdminToken } from "../../utils/adminAuth";
import { useTranslation } from "../../i18n";
import "./admin.css";

const { Title, Paragraph } = Typography;

function Admin() {
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleLogout = () => {
        clearAdminToken();
        navigate("/", { replace: true });
    };

    const tools = [
        { key: "bookings", label: t("booking.admin.title"), to: "/panel/bookings" },
        { key: "quote", label: t("quote.page.title"), to: "/quote" },
        { key: "delivery", label: t("delivery.admin.title"), to: "/d/admin" },
        { key: "delivery-manage", label: t("delivery.admin.manageTitle"), to: "/d/manage" },
        { key: "selection", label: t("selection.admin.title"), to: "/s/admin" },
        { key: "selection-manage", label: t("selection.admin.manageTitle"), to: "/s/manage" },
        { key: "selection-results", label: t("selection.results.title"), to: "/s/results" },
        { key: "feedback", label: t("feedback.admin.title"), to: "/panel/feedback" },
        { key: "video-review", label: t("videoReview.admin.title"), to: "/v/admin" },
        { key: "video-review-manage", label: t("videoReview.admin.manageTitle"), to: "/v/manage" },
        { key: "video-review-results", label: t("videoReview.results.title"), to: "/v/results" },
        { key: "retouch-review", label: t("retouchReview.admin.title"), to: "/r/admin" },
        { key: "retouch-review-manage", label: t("retouchReview.admin.manageTitle"), to: "/r/manage" },
        { key: "file-transfer", label: t("fileTransfer.admin.title"), to: "/t/admin" },
        { key: "file-transfer-manage", label: t("fileTransfer.admin.manageTitle"), to: "/t/manage" },
    ];

    return (
        <>
            <PageTitle>
                <Navigation />
            </PageTitle>
            <div className="admin-panel">
                <Title level={2}>{t("booking.panel.title")}</Title>
                <Paragraph type="secondary">{t("booking.panel.subtitle")}</Paragraph>
                <div className="admin-panel__tools">
                    {tools.map((tool) => (
                        <Button
                            key={tool.key}
                            type="primary"
                            size="large"
                            className="admin-panel__tool"
                            onClick={() => navigate(tool.to)}
                        >
                            {tool.label}
                        </Button>
                    ))}
                </div>
                <Button onClick={handleLogout}>{t("booking.panel.signOut")}</Button>
            </div>
            <Footer />
        </>
    );
}

export default Admin;
